<!-- 消息框 -->
<template>
  <div class="message">
    <header class="header">
      <div class="friendname">{{ sessionName || (selectedChat && selectedChat.user ? selectedChat.user.name : '加载中...') }}</div>
    </header>
    <div class="message-wrapper" ref="list" @scroll="handleScroll">
      <ul v-if="selectedChat" class="message-list">
        <!-- 加载更多历史消息按钮 -->
        <li v-if="pagination.hasMore && !loadingMore && messageHistory.length > 0" class="load-more-history">
          <button @click="loadMoreMessages" class="load-more-btn">加载更多历史消息</button>
        </li>
        <!-- 加载更多中状态 -->
        <li v-if="loadingMore" class="loading-more">
          <p>加载更多历史消息中...</p>
        </li>
        <!-- 消息列表 -->
        <li v-for="(item, i) in selectedChat.messages" class="message-item" :key="i">
          <div class="time"><span>{{ selectedChat.messages[i].date | time }}</span></div>
          <div class="main" :class="{ self: item.type === 1 }">
            <!-- type=1 显示机器人头像，type=0 显示firstName首字母 -->
            <template v-if="item.type === 1">
              <img class="avatar" width="36" height="36" src="/images/bot.png" />
            </template>
            <template v-else>
              <div class="avatar-text" :style="{ backgroundColor: getRandomAvatarColor(item.id || item.userId) }">
                {{ (item.firstName || item.userName || '')[0] || '用' }}
              </div>
            </template>
            <div class="content">
              <div class="text" v-html="replaceFace(item.content)"></div>
            </div>
          </div>
        </li>
        
        <!-- 暂无消息状态 -->
        <li v-if="selectedChat.messages.length === 0" class="empty-messages">
          <div class="empty-logo">
            <img src="/images/empty.svg" width="120" height="120" />
          </div>
          <!-- <div class="empty-text">暂无消息</div> -->
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getRequestParams, decodeFromBase64 } from '@/utils/getPrams.js';
import api from '../../api/api'
export default {
  props: {
    sessionId: {
      type: String,
      default: ''
    },
    sessionName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      authObj: null,
      selectedChat: null,
      currentUser: null,
      emojisWithReg: [],
      // 分页相关
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
        hasMore: true
      },
      loadingMore: false,
      loadingMessages: false,
      messageHistory: [], // 存储所有加载的消息历史
      // 轮询相关
      messagePollingInterval: null,
      pollingIntervalTime: 5000 // 轮询时间间隔，单位：毫秒
    }
  },
  created() {

    //console.log(this.sessionId);
    this.loadChatMessages(this.sessionId)
  },
  mounted() {

    //  在页面加载时让信息滚动到最下面
    setTimeout(() => this.$refs.list.scrollTop = this.$refs.list.scrollHeight, 0)
    // 启动轮询
    this.startMessagePolling();
  },
  beforeDestroy() {
    // 组件销毁时停止轮询
    this.stopMessagePolling();
  },
  watch: {
    // 会话ID变化时重新加载消息
    sessionId(newId, oldId) {
      // 只有当ID真正改变时才重新加载消息
      if (newId !== oldId) {
        this.loadChatMessages(newId)
        // 重新启动轮询
        this.startMessagePolling();
      }
    },
    // 移除消息变化时自动滚动到底部的监听，改为在特定场景手动控制
  },
  methods: {

    // 获取随机头像颜色
    getRandomAvatarColor(id) {
      const avatarColors = [
        '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4',
        '#FFEAA7', '#DDA0DD', '#98D8C8', '#F7DC6F',
        '#BB8FCE', '#85C1E2', '#F8C471', '#82E0AA'
      ];
      // 使用id作为种子获取一致的随机颜色
      const seed = parseInt(id) || id.charCodeAt(0) || 0;
      const index = seed % avatarColors.length;
      return avatarColors[index];
    },
    // 启动消息轮询
    startMessagePolling() {
      // 清除之前的定时器
      this.stopMessagePolling();

      // 只有当sessionId存在时才启动轮询
      if (this.sessionId) {
        this.messagePollingInterval = setInterval(() => {
          this.loadChatMessages(this.sessionId, false, true); // 添加isPolling参数
        }, this.pollingIntervalTime);
      }
    },
    // 停止消息轮询
    stopMessagePolling() {
      if (this.messagePollingInterval) {
        clearInterval(this.messagePollingInterval);
        this.messagePollingInterval = null;
      }
    },
    loadCurrentUser() {
      // api.getCurrentUser().then(user => {
      //     this.currentUser = user
      // })
    },
    loadChatMessages(id, isLoadMore = false, isPolling = false) {
      if (!id) return;

      // 设置加载状态
      if (isLoadMore) {
        this.loadingMore = true;
      } else if (!isPolling) {
        // 只有非轮询的首次加载才显示加载状态
        this.loadingMessages = true;
        // 重置分页和历史记录
        this.pagination.currentPage = 1;
        this.pagination.hasMore = true;
        this.messageHistory = [];
      }
      const urlParams = getRequestParams();
      this.authObj = decodeFromBase64(decodeURIComponent(urlParams));

      // 2. 解析为 JSON 对象（让数据更易读取和使用）

      //console.log(this.authObj);

      if (this.authObj.token && this.authObj.type == '2') {
        localStorage.setItem('sx-token', this.authObj.token);
      } else {
        localStorage.removeItem('sx-token');
        this.$router.push({
          path: '/login?' + urlParams

        });
      }
      // 构建分页参数，轮询时只获取1条最新消息
      const params = {
        pageNo: isLoadMore ? this.pagination.currentPage + 1 : 1,
        pageSize: isPolling ? 1 : this.pagination.pageSize, // 1 for polling, 20 otherwise
        robotId: this.authObj.robotId,
        column: 'createTime',
        order: 'desc'
      };

      // 根据id查询对应的聊天记录
      api.getChatMessages(id, params).then(response => {
        const res = response.data;
        if (res && res.code === 200 && res.result && Array.isArray(res.result.records)) {
          const records = res.result.records;
          const total = res.result.total || 0;

          // 转换消息格式，添加self属性（根据type判断）并按createTime升序排序
          const formattedMessages = records.map(msg => ({
            ...msg,
            // type=0是对方消息，type=1是自己的消息
            self: msg.type === 1,
            // 使用createTime作为date字段，保持与模板兼容
            date: msg.createTime
          })).sort((a, b) => new Date(a.createTime) - new Date(b.createTime)); // 时间最早的在最上面

          // 处理数据拼接和排序
          if (isLoadMore) {
            // 加载更多时，将新消息添加到历史消息前面，然后重新排序确保时间顺序正确
            this.messageHistory = [...this.messageHistory, ...formattedMessages].sort((a, b) => new Date(a.createTime) - new Date(b.createTime));
            this.pagination.currentPage++;
          } else {
            if (isPolling) {
              // 轮询时，处理最新的1条消息
              if (formattedMessages.length > 0) {
                const latestMessage = formattedMessages[0]; // API返回的最新消息（因为order=desc）
                const currentMessageIds = new Set(this.messageHistory.map(msg => msg.id));

                // 只有当消息不存在时才添加到列表末尾
                if (!currentMessageIds.has(latestMessage.id)) {
                  // 记录当前滚动位置和高度
                  const scrollContainer = this.$refs.list;
                  const isNearBottom = scrollContainer ?
                    (scrollContainer.scrollHeight - scrollContainer.scrollTop - scrollContainer.clientHeight < 100) :
                    true; // 默认true，兼容初始状态

                  // 添加新消息到列表并重新排序确保时间顺序正确
                  this.messageHistory.push(latestMessage);
                  this.messageHistory.sort((a, b) => new Date(a.createTime) - new Date(b.createTime));

                  // 只有当用户当前在底部附近时，才自动滚动到底部
                  this.$nextTick(() => {
                    if (scrollContainer && isNearBottom) {
                      scrollContainer.scrollTop = scrollContainer.scrollHeight;
                    }
                  });
                }
              }
            } else {
                // 首次加载时，保持消息列表按createTime升序，时间最早的在最上面
                this.messageHistory = [...formattedMessages];
                // 获取第一个消息的用户名作为聊天对象名称
                const chatUserName = (formattedMessages[0] && formattedMessages[0].userName) || '聊天对象';

              // 如果还没有创建selectedChat，初始化它
              if (!this.selectedChat) {
                this.selectedChat = {
                  messages: [],
                  user: { name: chatUserName }
                };
              } else {
                this.selectedChat.user.name = chatUserName;
              }
            }
          }

          // 确保selectedChat存在
          if (!this.selectedChat) {
            this.selectedChat = {
              messages: [],
              user: { name: '聊天对象' }
            };
          }
          // 更新selectedChat中的messages
          this.selectedChat.messages = this.messageHistory;

          // 更新分页状态
          this.pagination.total = total;
          this.pagination.hasMore = this.messageHistory.length < total;
        } else {
          console.error('Failed to load chat messages:', res.message || 'Unknown error');
          if (!isLoadMore) {
            // 显示错误提示
            this.selectedChat = {
              messages: [],
              user: { name: '加载失败' }
            };
          }
        }
      }).catch(error => {
        console.error('Error loading chat messages:', error);
        if (!isLoadMore) {
          // 显示错误提示
          this.selectedChat = {
            messages: [],
            user: { name: '加载失败' }
          };
        }
      }).finally(() => {
        // 请求完成后设置加载状态
        if (isLoadMore) {
          this.loadingMore = false;
          // 加载更多历史消息时，不要自动滚动到底部
          // 保持当前滚动位置，让用户继续查看历史消息
        } else {
          this.loadingMessages = false;
          // 只有真正的首次加载（非轮询、非发送消息后更新）才自动滚动到底部
          if (!isPolling) {
            this.$nextTick(() => {
              if (this.$refs.list) {
                this.$refs.list.scrollTop = this.$refs.list.scrollHeight;
              }
            });
          }
        }
      });
    },
    loadEmojis() {

    },
    // 更新消息列表
    updateMessages() {
      // 发送消息后的更新，不自动滚动
      this.loadChatMessages(this.sessionId, false, true)
    },
    // 加载更多历史消息
    loadMoreMessages() {
      if (this.loadingMore || !this.pagination.hasMore || !this.sessionId) return;
      this.loadChatMessages(this.sessionId, true);
    },
    // 在发送信息之后，将输入的内容中属于表情的部分替换成emoji图片标签
    // 再经过v-html 渲染成真正的图片
    replaceFace(con) {
      if (con.includes('/:')) {
        this.emojisWithReg.forEach(emoji => {
          con = con.replace(emoji.reg, '<img src="static/emoji/' + emoji.file + '"  alt="" style="vertical-align: middle; width: 24px; height: 24px" />')
        })
        return con;
      }
      return con;
    },
    // 处理滚动事件，滚动到顶部时加载更多历史消息
    handleScroll() {
      if (!this.$refs.list || this.loadingMore || !this.pagination.hasMore) return;

      // 当滚动到距离顶部20px以内时加载更多
      if (this.$refs.list.scrollTop <= 20) {
        this.loadMoreMessages();
      }
    }
  },
  filters: {
    // 将日期过滤为 hour:minutes
    time(date) {
      if (typeof date === 'string') {
        date = new Date(date);
      }
      if (date.getMinutes() < 10) {
        return date.getHours() + ':0' + date.getMinutes();
      } else {
        return date.getHours() + ':' + date.getMinutes();
      }
    }
  }
}
</script>

<style lang="less" scoped>
.message {
  width: 100%;
  height: 450px;

  .header {
    height: 60px;
    padding: 28px 0 0 30px;
    box-sizing: border-box;
    border-bottom: 1px solid #e7e7e7;

    .friendname {
      font-size: 18px;
    }
  }

  .message-wrapper {
    min-height: 390px;
    max-height: 390px;
    padding: 10px 15px;
    box-sizing: border-box;
    overflow-y: auto;
    border-bottom: 1px solid #e7e7e7;

    .message-list {
      margin: 0;
      padding: 0;
      list-style-type: none;
    }

    .message {
      margin-bottom: 15px;
    }

    .time {
      width: 100%;
      font-size: 12px;
      margin: 7px auto;
      text-align: center;

      span {
        display: inline-block;
        padding: 4px 6px;
        color: #fff;
        border-radius: 3px;
        background-color: #dcdcdc;
      }
    }

    .main {
      .avatar {
        float: left;
        margin-left: 15px;
      }

      .avatar-text {
        float: left;
        margin-left: 15px;
        border-radius: 3px;
        width: 36px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        color: white;
        font-size: 16px;
        font-weight: bold;
        overflow: hidden;
        display: inline-block;
      }

      .content {
        display: inline-block;
        margin-left: 10px;
        position: relative;
        padding: 6px 10px;
        max-width: 330px;
        min-height: 36px;
        line-height: 24px;
        box-sizing: border-box;
        font-size: 14px;
        text-align: left;
        word-break: break-all;
        background-color: #fafafa;
        border-radius: 4px;

        &:before {
          content: " ";
          position: absolute;
          top: 12px;
          right: 100%;
          border: 6px solid transparent;
          border-right-color: #fafafa;
        }
      }
    }
    
    /* 暂无消息状态样式 */
    .empty-messages {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 300px;
      color: #999;
      
      .empty-logo {
        margin-bottom: 20px;
        
        img {
          opacity: 0.6;
        }
      }
      
      .empty-text {
        font-size: 16px;
        color: #666;
      }
    }

    .self {
      text-align: right;

      .avatar {
        float: right;
        margin: 0 15px;
      }

      .avatar-text {
        float: right;
        margin: 0 15px;
      }

      .content {
        background-color: #b2e281;

        &:before {
          right: -12px;
          vertical-align: middle;
          border-right-color: transparent;
          border-left-color: #b2e281;
        }
      }
    }
  }

  /* 加载更多历史消息样式 */
  .load-more-history {
    display: flex;
    justify-content: center;
    padding: 10px 0;

    .load-more-btn {
      padding: 4px 16px;
      background-color: rgba(0, 122, 255, 0.1);
      color: #007aff;
      border: 1px solid rgba(0, 122, 255, 0.3);
      border-radius: 15px;
      font-size: 12px;
      cursor: pointer;
      transition: all 0.2s;

      &:hover {
        background-color: rgba(0, 122, 255, 0.2);
        border-color: rgba(0, 122, 255, 0.5);
      }

      &:active {
        background-color: rgba(0, 122, 255, 0.3);
      }
    }
  }

  /* 加载更多中样式 */
  .loading-more {
    display: flex;
    justify-content: center;
    padding: 10px 0;
    color: #999;
    font-size: 12px;
  }
}
</style>
